module.exports = __webpack_public_path__ + "static/kieran-and-ruth.1c94ea80.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/avatars/kieran-and-ruth.jpg
// module id = 281
// module chunks = 168707334958949